import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../appstate';
import {ServerInfo} from '../../data/server-info';
import {PushServerInfo} from '../../data/push-server-info';
import {Observable} from 'rxjs';
import { filter } from 'rxjs/operators';
/**
 * Created by ashok on 10/05/17.
 */

@Injectable()
export class ServerInfoDataService {
    constructor(private store: Store<AppState>){}

    public getServerInfo(): Promise<ServerInfo> {
        return this.store.select((appState:any)=>appState.reducers.serverInfo).toPromise();
    }

    public getPushServerInfo(): Promise<PushServerInfo> {
        return this.store.select((appState:any)=>appState.reducers.serverInfo.pushServerInfo).toPromise();
    }
    public showAds(): Observable<boolean> {
        return this.store.select(appState => appState.serverInfo.showAds);
    }

    public adUrls(): Observable<string[]> {
        return this.store
                   .select(appState => appState.serverInfo.adUrls).pipe(filter(Boolean));
    }
}